import { config } from '@uhg-abyss/web/tools/config';

import { Constants } from '../../common/Constants';
import { ConstantsLagoon } from '../../common/ConstantsLagoon';
import {
  PriorityItem,
  updatePopoverPriority,
} from '../../utils/priorityPopover';
import { useCustomQuery } from '../useCustomQuery';
import { useFeatureFlag } from '../useFeatureFlag';
import { useLagoon } from '../useLagoon';
import GET_EDUCATIONAL_CONTENT_STATUS from './EducationalContentStatus.graphql';
import SAVE_EDUCATIONAL_CONTENT_STATUS from './SaveEducationalContentStatus.graphql';

export const useEducationalContentStatus = (options) => {
  const priorityList = useLagoon(
    Constants.LAGOON_TABLE.POPOVER_PRIORITIES
  )() as PriorityItem[];
  const [enablePopoverPriorityFlow] = useFeatureFlag([
    ConstantsLagoon.FEATURE_FLAGS.ENABLE_POPOVER_PRIORITY_FLOW,
  ]);

  const [queryResult, queryActions] = useCustomQuery(
    GET_EDUCATIONAL_CONTENT_STATUS,
    {
      url: config('GRAPHQL_API_URL'),
      accessor: 'educationalContentStatus',
      ...options,
      onCompleted: (result) => {
        if (enablePopoverPriorityFlow) {
          const isSuperUser =
            JSON.parse(result?.config?.data)?.variables?.isSuperUser || false;
          updatePopoverPriority(result, priorityList, isSuperUser);
        }
      },
    }
  );

  return [queryResult, queryActions];
};

export const useSaveEducationalContentStatus = (options) => {
  const priorityList = useLagoon(
    Constants.LAGOON_TABLE.POPOVER_PRIORITIES
  )() as PriorityItem[];
  const [enablePopoverPriorityFlow] = useFeatureFlag([
    ConstantsLagoon.FEATURE_FLAGS.ENABLE_POPOVER_PRIORITY_FLOW,
  ]);
  const [queryResult, queryAction] = useCustomQuery(
    SAVE_EDUCATIONAL_CONTENT_STATUS,
    {
      url: config('GRAPHQL_API_URL'),
      accessor: 'saveEducationalContentStatus',
      ...options,

      onCompleted: (result) => {
        if (enablePopoverPriorityFlow) {
          const isSuperUser =
            JSON.parse(result?.config?.data)?.variables?.isSuperUser || false;
          updatePopoverPriority(result, priorityList, isSuperUser);
        }
      },
    }
  );
  return [queryResult, queryAction];
};
